<template>
  <div class="go-record mt-80">
    <b-alert
      :show="dismissCountDown"
      fade
      variant="success"
      class="success-alert2"
      style="width: 200px; margin-bottom: 0;"
      @dismiss-count-down="countDownChanged"
    >
      Заявка отправленна
    </b-alert>
    <three-dots class="dots mt-5" />
    <div class="title">Записаться на сеанс сейчас</div>
    <form class="form1" @submit.prevent="submit">
      <img src="@/assets/bgdots.png" class="bgDots" alt="">
      <div class="form">
        <p class="form-discription">Пожалуйста, заполните форму. Я обязательно вернусь к вам как можно скорее. Напишите мне ваши варианты времени в течение дня в сообщении. Это ускорит наше последующее общение.</p>
        <p class="form-label mb-1 mt-4">Имя и фамилия <span>*</span></p>
        <b-form-input
          v-model="name"
          name="name"
          :state="validateState('name')"
          v-validate="'required'"/>
        <p class="form-label mb-1 mt-2">Номер телефона <span>*</span></p>
        <b-form-input
          v-model="number"
          name="number"
          type="number"
          :state="validateState('number')"
          v-validate="'required'"/>
        <p class="form-label mb-1 mt-2">E-mail <span>*</span></p>
        <b-form-input
          v-model="email"
          name="email"
          :state="validateState('email')"
          v-validate="'required|email'"/>
        <p class="form-label mb-1 mt-2">Краткое описание проблемы <span>*</span></p>
       <b-form-group>
         <b-form-textarea
           v-model="problem"
           name="problem"
           :state="validateState('problem')"
           v-validate="'required'">
         </b-form-textarea>
       </b-form-group>
        <div class="d-flex align-items-center mt-3">
          <b-form-checkbox
            v-model="check"
            name="check"
            :state="validateState('check')"
            v-validate="'required:true'"/>
          <p>Я согласен на обработку персональных данных: информация является конфиденциальной и предназначена только для связи с психологом.</p>
        </div>
        <b-button type="submit" class="button">Отправить <under-arrow/></b-button>
      </div>
    </form>
  </div>
</template>

<script>
  import ThreeDots from '@/components/icons/ThreeDots';
  import UnderArrow from '@/components/icons/UnderArrow';
  import {mapActions} from 'vuex';
  import validate from '@/mixins/validate';
  export default {
    name: "GoRecord",
    components: {ThreeDots, UnderArrow},
    mixins: [validate],
    data() {
      return {
        name: '',
        number: '',
        email: '',
        problem: '',
        check: false,
        dismissCountDown: 0
      }
    },
    methods: {
      ...mapActions('request', ['addRequest']),
      async submit() {
        this.$validator.validate().then( async valid => {
          if (!valid) return
          await this.addRequest({name: this.name, number: this.number, mail: this.email, problem: this.problem, been_read: false})
          this.dismissCountDown = 2
          this.clearFields()
        });
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      clearFields() {
        this.name = '';
        this.number = '';
        this.email = '';
        this.problem = '';
        this.check = false
        this.$validator.reset();
      }
    }
  }
</script>

<style lang="scss">
  .success-alert2 {
    position: fixed !important;
    top: 80px;
    right: 0;
    z-index: 3;
  }
  .go-record {
    .bgDots {
      position: absolute;
      z-index: 2;
      right: -45px;
      top: -45px;
      max-width: 134px;
      width: 100%;
    }
    .title {
      margin-bottom: 53px !important;
    }
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    border-color: #007bff !important;
    background-color: #007bff !important;
  }
  .form1:after {
    width: 100%;
    height: 100%;
    display: block;
    background: #fff;
    position: absolute;
    border: 1px solid #7e7e7e;
    content: '';
    z-index: 1;
    left: -20px;
    top: 20px;
    border-radius: 9px;
  }
  .form1 {
    max-width: 615px;
    margin-left: auto;
    margin-right: auto;
    font-family: 'Raleway', sans-serif;
    position: relative;
    z-index:2;
    bottom: -20px;
    margin-bottom: 100px;
    .form {
      position: relative;
      background-color: #e8f4ff;
      border-radius: 9px;
      z-index:2;
      padding: 32px 120px;
      &-discription {
        font-size: 12px;
        line-height: 1.56;
        color: #7e7e7e;
      }
      input.form-control, textarea {
        border: none;
        border-radius: 9px;
      }
      textarea {
        height: 155px;
      }
      &-label {
        font-size: 17px;
        line-height: 1.56;
        color: #1f1f1f;
        font-weight: 300;
        span {
          color: #ff0000;
        }
      }
      .d-flex {
        input {
          border-radius: 2px;
          box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.25);
          background-color: #ffffff;
          border: none;
        }
        p {
          font-size: 12px;
          line-height: 1.56;
          margin: 0;
          color: #7e7e7e;
        }
      }
      .button {
        width: 181px;
        height: 48px;
        border-radius: 9px;
        background-color: #55cce7;
        margin-right: 32px;
        font-size: 17px;
        font-weight: 600;
        border: none;
        color: #ffffff;
        margin-top: 24px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        svg {
          transform: rotate(-90deg);
          margin-left: 15px;
        }
      }
    }
  }

  @media screen and (max-width: 768px){
    .go-record {
      padding: 0 24px;
      .bgDots {
        display: none;
      }
      .title {
        margin-bottom: 32px;
      }
      form:after {
        display: none;
      }
      form {

      }
    }
  }
  @media screen and (max-width: 615px){
    .go-record {
      padding: 0 24px;
      .title {
        margin-bottom: 30px !important;
      }
      form {
        .form {
          padding: 24px 64px;
        }
      }
    }
  }
  @media screen and (max-width: 500px){
    .go-record {
      padding: 0 24px;
      .title {
        margin-bottom: 24px !important;
      }
      form {
        .form {
          padding: 24px;
        }
      }
    }
  }
</style>